import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetBuildings_buildingIdCardExportPdf = z.any()
export type TagsGetBuildings_buildingIdCardExportPdf = z.infer<typeof tagsGetBuildings_buildingIdCardExportPdf>

export const paramsGetBuildings_buildingIdCardExportPdf = z.object({ "buildingId": z.string().uuid() })
export type ParamsGetBuildings_buildingIdCardExportPdf = z.infer<typeof paramsGetBuildings_buildingIdCardExportPdf>

export const responseGetBuildings_buildingIdCardExportPdf = z.any()
export type ResponseGetBuildings_buildingIdCardExportPdf = z.infer<typeof responseGetBuildings_buildingIdCardExportPdf>

interface IGetBuildings_buildingIdCardExportPdf extends BaseMethodType {
  tags: TagsGetBuildings_buildingIdCardExportPdf,
  params: ParamsGetBuildings_buildingIdCardExportPdf,
  response: ResponseGetBuildings_buildingIdCardExportPdf
}
export const URL = '/buildings/:buildingId/card/export/pdf'
export const validation = {
  get: {
    tags: tagsGetBuildings_buildingIdCardExportPdf,
    params: paramsGetBuildings_buildingIdCardExportPdf,
    response: responseGetBuildings_buildingIdCardExportPdf
  }
}
export interface Buildings_buildingIdCardExportPdf extends BaseRouteType {
  get: IGetBuildings_buildingIdCardExportPdf
}